export enum PrimaryFunction {
    sales = 'Sales',
    service = 'Service',
    management = 'Management',
    marketing = 'Marketing',
    operations = 'Operations',
    other = 'Other',
}